import { Controller } from 'react-hook-form';
import { Select, useTheme } from '@mui/material';

import { getAutomationDropdownSx } from 'features/Automations/styles';
import { AutomationDropdownProps } from 'features/Automations/types';

export const AutomationDropdown: React.FC<AutomationDropdownProps> = ({
  dataTestId,
  children,
  name,
  defaultValue,
  isRequired = true,
  sx,
}) => {
  const theme = useTheme();

  return (
    <Controller
      name={name}
      defaultValue={defaultValue}
      rules={{
        required: isRequired,
      }}
      render={({ field: { onChange, value } }) => {
        const displayValue = value ?? defaultValue ?? '';
        return (
          <Select
            data-testid={dataTestId}
            variant="outlined"
            onChange={(event) => {
              onChange(event.target.value);
            }}
            sx={{
              ...getAutomationDropdownSx(theme),
              ...sx,
            }}
            value={displayValue}
            displayEmpty
          >
            {children}
          </Select>
        );
      }}
    />
  );
};
